import { BulkMessageSenderInput, User } from "@/__generated__/graphql";
import { i18n } from "@/i18n";
import { useCounselors } from "@/hooks/useCounselors";

interface SenderTextProps {
  sender?: BulkMessageSenderInput;
}

export function SenderText({ sender }: SenderTextProps) {
  const { data: counselors, loading } = useCounselors();

  if (loading) {
    return i18n.t("global.loading");
  }

  return formattedText(sender, counselors || []);
}

function formattedText(
  sender?: BulkMessageSenderInput,
  counselors?: Partial<User>[],
) {
  if (sender?.assignedCounselor) {
    return i18n.t(
      "bulkMessaging.composeMessage.inputs.sendFrom.assignedCounselor",
    );
  } else if (sender?.userId) {
    const counselor = counselors?.find((c) => c?.id === sender?.userId);
    if (counselor) {
      return `${counselor.firstName} ${counselor.lastName}`;
    } else {
      return i18n.t("bulkMessaging.review.formerOfficial");
    }
  } else {
    return "-";
  }
}
